// PropertyLayout.js
import { __ } from '@wordpress/i18n';
import { useRef, useState } from 'react';
import DynamicField from './DynamicField';
import './PropertyLayout/SidebarSection/sidebarWidget.css';

const PropertyLayout = ({ 
  dynamicFields, 
  onOpenModal, 
  onRemoveField,
  onEditField,
  onMoveFieldUp,
  onMoveFieldDown
}) => {
  const [activeMoveId, setActiveMoveId] = useState(null);
  const activeMoveIdRef = useRef(null);

  const renderDynamicFields = (area) => {
    const fields = dynamicFields[area] || [];
    
    return fields.map((field, index) => (
      <DynamicField
        key={field.id}
        field={field}
        area={area}
        onEdit={onEditField}
        onDelete={onRemoveField}
        onMoveUp={onMoveFieldUp}
        onMoveDown={onMoveFieldDown}
        canMoveUp={index > 0}
        canMoveDown={index < fields.length - 1}
        isMoving={activeMoveId === field.id}
      />
    ));
  };

  const handleMoveUp = (area, fieldId, e) => {
    e.stopPropagation();
    
    // Prevent multiple moves
    if (activeMoveIdRef.current) return;
    activeMoveIdRef.current = fieldId;
    
    setActiveMoveId(fieldId);
    onMoveFieldUp(area, fieldId);
    
    // Reset the ref after a short delay
    setTimeout(() => {
      activeMoveIdRef.current = null;
      setActiveMoveId(null);
    }, 300);
  };

  const handleMoveDown = (area, fieldId, e) => {
    e.stopPropagation();
    
    // Prevent multiple moves
    if (activeMoveIdRef.current) return;
    activeMoveIdRef.current = fieldId;
    
    setActiveMoveId(fieldId);
    onMoveFieldDown(area, fieldId);
    
    // Reset the ref after a short delay
    setTimeout(() => {
      activeMoveIdRef.current = null;
      setActiveMoveId(null);
    }, 300);
  };

  const handleEdit = (field, area, e) => {
    e.stopPropagation();
    e.preventDefault();
    onEdit(field, area);
  };

  const handleDelete = (area, fieldId, e) => {
    e.stopPropagation();
    onRemoveField(area, fieldId);
  };

  return (
    <div className="hvnly--builder---api_property__singleProperty__builder__tab_content_panel">
      <div className="hvnly--builder---api_property__singleProperty__builder__container">
        <div className="hvnly--builder---api_property__singleProperty__builder__main">
          <div className="hvnly--builder---api_property__singleProperty__builder__preview_section">
            <div className="hvnly--builder---api_property__singleProperty__builder__single_item">
              {/* Property Header with Image Gallery */}

              <div className="hvnly--builder---api_property__singleProperty__builder__gallery">
                <div className="hvnly--builder---api_property__singleProperty__builder__gallery_thumbnail">
                  <i className="fas fa-images"></i>
                </div>
                
                {/* Gallery Center Options - Carousel or Map */}
                <div className="hvnly--builder---api_property__singleProperty__builder__gallery_center">
                  <div className="hvnly--builder---api_property__singleProperty__builder__editable_area">
                    <span className="hvnly--builder---api_property__singleProperty__builder__area_label">{__('Gallery Type', 'havenlytics')}</span>
                    <div 
                      className="hvnly--builder---api_property__singleProperty__builder__add_element_btn" 
                      data-area="gallery"
                      onClick={(e) => onOpenModal('gallery', e.currentTarget)}
                    >
                      <i className="fas fa-plus"></i>
                    </div>
                    
                    {/* Dynamic Fields for Gallery - Only one field allowed */}
                    {renderDynamicFields('gallery')}
                  </div>
                </div>
              </div>
              
              <div className="hvnly--builder---api_property__singleProperty__builder__body">
                {/* Title Area */}
                <div className="hvnly--builder---api_property__singleProperty__builder__editable_area">
                  <span className="hvnly--builder---api_property__singleProperty__builder__area_label">{__('Title Area', 'havenlytics')}</span>
                  
                  
                  <div className="hvnly--builder---api_property__singleProperty__builder__title_area">
                    <div className="hvnly--builder---api_property__singleProperty__builder__title_block_area_left">
                    <div 
                      className="hvnly--builder---api_property__singleProperty__builder__add_element_btn" 
                      data-area="title"
                      onClick={(e) => onOpenModal('title', e.currentTarget)}
                    >
                      <i className="fas fa-plus"></i>
                    </div>
                     {renderDynamicFields('title')}
              
                     
                    </div>
                    <div className="hvnly--builder---api_property__singleProperty__builder__title_block_area_right">
                   <div 
                      className="hvnly--builder---api_property__singleProperty__builder__add_element_btn hvnly--builder---api_property__singleProperty__builder__add_element_btn_tags" 
                      data-area="tags"
                      onClick={(e) => onOpenModal('tags', e.currentTarget)}
                    >
                      <i className="fas fa-plus"></i>
                    </div>

                        {renderDynamicFields('tags')}
                
                      
                    </div>

                  </div>
                </div>
                
                {/* Property Details Overview */}
                <div className="hvnly--builder---api_property__singleProperty__builder__editable_area">
                  <span className="hvnly--builder---api_property__singleProperty__builder__area_label">{__('Details Overview', 'havenlytics')}</span>
                  <div 
                    className="hvnly--builder---api_property__singleProperty__builder__add_element_btn" 
                    data-area="details"
                    onClick={(e) => onOpenModal('details', e.currentTarget)}
                  >
                    <i className="fas fa-plus"></i>
                  </div>
                  
                  {/* Details Grid Container */}
                              <div className="hvnly--builder---api_property__singleProperty__builder__features">
                    <h2>{__('Details Overview', 'havenlytics')}</h2>
                    {/* Dynamic Fields - Now rendered INSIDE the grid at the end */}
                    {renderDynamicFields('details')}
                  </div>

                  
                </div>
                
                {/* Property Features */}
                <div className="hvnly--builder---api_property__singleProperty__builder__editable_area">
                  <span className="hvnly--builder---api_property__singleProperty__builder__area_label">{__('Features', 'havenlytics')}</span>
                  <div 
                    className="hvnly--builder---api_property__singleProperty__builder__add_element_btn" 
                    data-area="features"
                    onClick={(e) => onOpenModal('features', e.currentTarget)}
                  >
                    <i className="fas fa-plus"></i>
                  </div>
                  
                  <div className="hvnly--builder---api_property__singleProperty__builder__features">
                    <h2>{__('Features & Amenities', 'havenlytics')}</h2>
                    {renderDynamicFields('features')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
       {/* Sidebar */}
        <div className="hvnly--builder---api_property__singleProperty__builder__sidebar">
          {/* NEW: Agent Info Card */}
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card">
            <div className="hvnly--builder---api_property__singleProperty__builder__editable_area">
              <span className="hvnly--builder---api_property__singleProperty__builder__area_label">{__('Agent Info', 'havenlytics')}</span>
              <div 
                className="hvnly--builder---api_property__singleProperty__builder__add_element_btn" 
                data-area="agent_info"
                onClick={(e) => onOpenModal('agent_info', e.currentTarget)}
              >
                <i className="fas fa-plus"></i>
              </div>
              
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_header">
                <i className="fas fa-user-tie"></i>
                <h3>{__('Contact Agent', 'havenlytics')}</h3>
              </div>
              
              {/* Render dynamic fields for agent_info area */}
              {renderDynamicFields('agent_info')}
              
              {/* Default content when no agent info field is selected */}
              {(!dynamicFields.agent_info || dynamicFields.agent_info.length === 0) && (
                <div className="hvnly--builder---api_property__singleProperty__builder__agent_info_default">
                  <p>{__('Click the + button to add Agent Info or Contact Form', 'havenlytics')}</p>
                </div>
              )}
            </div>
          </div>


          {/* Property Amenities Card */}
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card">
            <div className="hvnly--builder---api_property__singleProperty__builder__editable_area">
              <span className="hvnly--builder---api_property__singleProperty__builder__area_label">{__('Amenities', 'havenlytics')}</span>
              <div 
                className="hvnly--builder---api_property__singleProperty__builder__add_element_btn" 
                data-area="amenities"
                onClick={(e) => onOpenModal('amenities', e.currentTarget)}
              >
                <i className="fas fa-plus"></i>
              </div>
              
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_header">
                <i className="fas fa-list-ul"></i>
                <h3>{__('Property Amenities', 'havenlytics')}</h3>
              </div>
              {renderDynamicFields('amenities')}
            </div>
          </div>
          
          {/* Property Featured Card */}
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card">
            <div className="hvnly--builder---api_property__singleProperty__builder__editable_area">
              <span className="hvnly--builder---api_property__singleProperty__builder__area_label">{__('Featured', 'havenlytics')}</span>
              <div 
                className="hvnly--builder---api_property__singleProperty__builder__add_element_btn" 
                data-area="featured"
                onClick={(e) => onOpenModal('featured', e.currentTarget)}
              >
                <i className="fas fa-plus"></i>
              </div>
              
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_header">
                <i className="fas fa-star"></i>
                <h3>{__('Property Featured', 'havenlytics')}</h3>
              </div>
              {renderDynamicFields('featured')}

            </div>
          </div>
          
          {/* Property Views This Week Card */}
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card">
            <div className="hvnly--builder---api_property__singleProperty__builder__editable_area">
              <span className="hvnly--builder---api_property__singleProperty__builder__area_label">{__('Views', 'havenlytics')}</span>
              <div 
                className="hvnly--builder---api_property__singleProperty__builder__add_element_btn" 
                data-area="views"
                onClick={(e) => onOpenModal('views', e.currentTarget)}
              >
                <i className="fas fa-plus"></i>
              </div>
              
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_header">
                <i className="fas fa-chart-line"></i>
                <h3>{__('Views This Week', 'havenlytics')}</h3>
              </div>
              {renderDynamicFields('views')}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyLayout;